import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Font,
    PDFViewer,
    Image,
} from "@react-pdf/renderer";
import { useEvent } from "../context/eventContext";
import { getSelectedElement, myTimestampToDate } from "../utils/ui_utils";
import { format, isSameDay } from "date-fns";
import { getCross } from "../definitions/cow";
import { logopath } from "../definitions/anafilogo";

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});


// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: "#fff",
        color: "black",
        margin: 0,
        fontSize: 10,
        padding: 10,
        paddingBottom: 30
    },
    section: {
        margin: 10,
        padding: 10,
    },
    header: {
        padding: 10,
        marginBottom: 5,
        flexDirection: "row",
        flexWrap: "wrap",
        borderBottom: '1px solid #3D79D1',
        justifyContent: "center",
        fontWeight: 'bold',
        verticalAlign: "center",
    },
    title: {
        fontSize: '14px',
        backgroundColor: '#3D79D1',
        padding: 2,
        marginBottom: 5,
        color: 'white',
        fontWeight: 'bold',
        textAlign: "center"
    },
    subtitle: {
        borderTop: '1px solid #3D79D1',
        borderBottom: '1px solid #3D79D1',
        fontSize: '14px',
        padding: 2,
        marginBottom: 10,
        fontWeight: 'bold',
        textAlign: "center"
    },
    catalog: {
        textAlign: 'right',
        fontFamily: "Helvetica-Bold",
        width: '20px',
    },
    position: {
        textAlign: 'center',
        fontFamily: "Helvetica-Bold",
        borderRadius: 10,
        backgroundColor: '#999',
        color: '#fff',
        width: '20px',
    },
    judge_row: {
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        fontWeight: 'bold',
        verticalAlign: "center",
    },
    judge_container: {
        alignItems: "right",
        textAlign: 'center',
        width: '30%',
        marginTop: 20,
    },
    highlight: {
        color: 'black',
        fontFamily: "Helvetica-Bold",
    },
    image: {
        height: 20,
        marginRight: 10
    },
    cow_container: {
        flexDirection: "row",
        flexWrap: "wrap",
        margin: 0,
        padding: 0,
        alignItems: "center", // Aligns text vertically in the center
    },
    cow_container_big: {
        flexDirection: "column",
        flexWrap: "wrap",
        margin: 0,
        padding: 0,
    },
    cow_container_border: {
        marginBottom: 1,
        marginTop: 1,
    },
    cowname: {
        fontFamily: "Helvetica-Bold"
    },
    label: {
        fontSize: 8
    },
    subsection: {
        margin: 10,
        padding: 10,
    },
    firstrow: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        fontSize: '40px',
        fontFamily: "Helvetica-Bold"
    },
    section_title: {
        borderBottom: '1px solid black',
        textAlign: 'center',
        fontSize: '10px',
        color: '#3D79D1',
        paddingBottom: 2,
        marginTop: 2
    },
    footer: {
        borderTop: '1px solid #3D79D1',
        textAlign: 'center',
        position: 'absolute',
        fontSize: 10,
        bottom: 10,
        left: 10,
        right: 10,
        paddingTop: 5,
        textAlign: 'center',
        color: 'grey',

    },
    viewer: {
        width: window.innerWidth - 100, //the pdf viewer will take up all of the width and height
        height: window.innerHeight - 200,
    },
});


const OtherlistPdf = ({ doc_data, p_type, is_multi }) => {
    const { selEvent } = useEvent()
    console.log("SEL EVENT", selEvent)

    const ev_start = myTimestampToDate(selEvent.event_start)
    const ev_end = myTimestampToDate(selEvent.event_end)
    let ev_date = format(ev_start, 'dd/MM/yyyy')
    if (!isSameDay(ev_start, ev_end)) {
        ev_date = `${format(ev_start, 'dd')}-${format(ev_end, 'dd /MM/yyyy')}`
    }
    if (p_type === 'cowman') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Elenco allevatori`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"} >
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} />
                        <View style={styles.title}><Text>Elenco allevatori</Text></View>
                        {doc_data.cowman_list?.map((c, k) => (
                            <OneCowman key={k} cowman={c} cowman_data={doc_data.cowman_data[c.id]} index={k} selEvent={selEvent} />
                        ))}
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )
    } else if (p_type === 'property') {
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - Elenco aziende`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"}>
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>Elenco aziende</Text></View>
                        {doc_data.property_list?.map((c, k) => (
                            <OneProperty key={k} property={c} property_data={doc_data.property_data[c.id]} index={k} selEvent={selEvent} />
                        ))}
                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )

    } else if (p_type === 'globalsummary') {
        console.log("GLOBALSYMMARY", doc_data)
        return (
            <PDFViewer style={styles.viewer} showToolbar={true}>
                <Document title={`${selEvent.event_name} - ${doc_data.title}`} author={"ANAFIBJ"} creator={"Showtime ANAFIBJ"}>
                    <Page size="A4" style={styles.page}>
                        <PageHeader selEvent={selEvent} fixed />
                        <View style={styles.title}><Text>{doc_data.title}</Text></View>
                        <View style={{ flexDirection: "row" }}>
                            <View style={{ width: '40px' }}></View>
                            <View style={{ width: '100px' }}>
                                <Text>Giudice ufficiale:</Text>
                            </View>
                            <Text style={styles.highlight}>&nbsp;{selEvent.judge?.firstname} {selEvent.judge?.lastname} </Text>
                        </View>
                        {doc_data.summary_data.map((s, k) => (
                            <View style={{ flexDirection: "row" }} key={k}>
                                <View style={{ width: '40px' }}></View>
                                <View style={{ width: '100px' }}>
                                    <Text>{s.title}:</Text>
                                </View>
                                <Text style={styles.highlight}>&nbsp;{s.data_list?.length}</Text>
                            </View>
                        ))}
                        <View style={{ marginBottom: 10 }}>
                        </View>
                        {doc_data.data_list.map((c, k) => {
                            if (c.type === 'divider') {
                                return (<Text break></Text>)
                            } else {
                                return (
                                    <OneMatch match={c} key={k} ev_date={ev_date} />
                                )
                            }
                        })}

                        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />
                    </Page>
                </Document>
            </PDFViewer>
        )

    }
}





const PageHeader = ({ selEvent }) => {
    const ev_start = myTimestampToDate(selEvent.event_start)
    const ev_end = myTimestampToDate(selEvent.event_end)
    let ev_date = format(ev_start, 'dd/MM/yyyy')
    if (!isSameDay(ev_start, ev_end)) {
        ev_date = `${format(ev_start, 'dd')}-${format(ev_end, 'dd /MM/yyyy')}`
    }

    return (

        <View style={styles.header} fixed>
            {selEvent.document_show_logo &&
                <Image
                    style={styles.image}
                    src={logopath}
                />
            }
            <View style={{ flex: 2, fontFamily: "Helvetica-Bold" }}>
                <Text>
                    {selEvent.event_name}
                </Text>
            </View>
            <View style={{ flex: 2 }}>
                <Text>
                    {selEvent.location?.name}
                </Text>
            </View>
            <View style={{ flex: 1 }}>
                <Text>
                    {ev_date}
                </Text>
            </View>
            {selEvent.document_show_customlogo && selEvent.logo &&
                <Image
                    style={styles.image}
                    src={selEvent.logo}
                />
            }

        </View>
    )
}


const OneMatch = ({ match, ev_date }) => {
    console.log("PDF MNATCHG", match)
    return (
        <View style={{ marginTop: 3 }}>
            <View flexDirection="row" style={[styles.subtitle, { marginBottom: 2 }]}>
                <Text>
                    {match.section_title}
                </Text>
            </View>
            <View style={{ paddingLeft: '5px' }}>
                {match.cow_list?.map((c, k) => (
                    <OneCow c_type='postresult' cow={{ cow: c, award_label: match.award_label ? match.award_label[k] : '' }} key={k} ev_date={ev_date} index={k} award_value={match.award_value} />
                ))}
                {match.element_list?.map((g, k) => (
                    <OneGroup group={g} key={k} index={k} />
                ))}
            </View>
        </View>


    )
}

const OneGroup = ({ group, index }) => {
    console.log("G", group)

    return (
        <>
            <View style={[styles.cow_container, { borderBottom: '1px solid #aaa', paddingTop: 5, backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>
                <View style={{ flex: 0.3 }}>
                    {index >= 0 &&
                        <Text style={styles.position}>{index + 1}</Text>
                    }
                </View>
                <View style={{ width: '45px' }}>
                    <Text style={{ width: '45px' }}>
                        {group.cdaua_cowman || group.cdaua}
                    </Text>
                </View>
                <View style={{ flex: 7 }}>
                    <Text >
                        {group.name}
                    </Text>
                </View>
                <View style={{ flex: 0.3, flexDirection: 'row' }} >
                    <Text style={styles.cowname}>{group.total_point}</Text>
                    <Text>pt</Text>
                </View>
            </View>
        </>
    )
}

const OneCowman = ({ cowman, cow_list, ev_date, show_list, index, cowman_data }) => {
    return (

        <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>
            <View flexDirection="row" style={{ marginTop: '5px', flexDirection: "row", justifyContent: "space-between", flex: 1 }}>
                <Text>
                    {console.log("COWMAN", cowman)}
                    <Text style={{ width: '40px' }}>{cowman.cdaua}&nbsp;</Text>
                    <Text style={{ marginLeft: '4px' }}>{cowman.name}</Text>
                    <Text style={{ marginLeft: '4px', fontSize: 7 }}>
                        <Text>&nbsp;</Text>
                        <PlaceSection data={cowman} />
                    </Text>

                </Text>
                {cowman_data !== undefined ?
                    <Text style={{ fontSize: 8, width: '30px', textAlign: "center" }}>
                        {cowman_data.count_present} / {cowman_data.count_total}
                    </Text>
                    :
                    <></>}
            </View>
            {show_list ?
                <View style={{ paddingLeft: '5px' }}>
                    {cow_list.map((c, k) => (
                        <OneCow c_section='cowman' cow={c} key={k} ev_date={ev_date} index={k} />
                    ))}
                </View>
                :
                <></>}
        </View>


    )
}

const OneProperty = ({ property, cow_list, ev_date, show_list, index, property_data }) => {
    return (
        <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>
            <View flexDirection="row" style={{ marginTop: '5px', flexDirection: "row", justifyContent: "space-between", flex: 1 }}>
                <Text>
                    <Text style={{ width: '40px' }}>{property.cdaua}&nbsp;</Text>
                    <Text style={{ marginLeft: '2px' }}>{property.name}</Text>
                    <Text style={{ marginLeft: '4px', fontSize: 8 }}>
                        <Text>&nbsp;</Text>
                        <PlaceSection data={property} />
                    </Text>
                </Text>
                {property_data !== undefined ?
                    <Text style={{ fontSize: 8, width: '30px', textAlign: "center" }}>
                        {property_data.count_present} / {property_data.count_total}
                    </Text>
                    : <></>}
            </View>
            {show_list ?
                <View style={{ paddingLeft: '5px' }}>
                    {cow_list.map((c, k) => (
                        <OneCow c_section='cowman' cow={c} key={k} ev_date={ev_date} index={k} />
                    ))}
                </View>
                : <></>}
        </View>


    )
}


const PlaceSection = ({ data }) => {

    return (<>
        {data.comune ? <Text style={{ fontSize: 8 }}>{data.comune} - </Text> : <></>}
        {data.provincia ? <Text>{data.provincia} - </Text> : <></>}
        {data.regione ? <Text>{data.regione}</Text> : <></>}
    </>)

}



const OneCow = ({ cow, c_type, index, award_value }) => {


    let property_string = cow.property?.name || ''
    if (cow.coproperty && cow.coproperty.length > 0) {
        property_string = property_string + " (" + cow.coproperty + ") "
    }
    console.log("COPROPERTY??", property_string, cow.coproperty)
    if (cow.property && cow.property.provincia && cow.property.provincia.length > 0) {
        property_string = property_string + " - " + cow.property.provincia
    }
    let catalog_id = '___'
    if (cow.cow && cow.cow.catalog_id){
        catalog_id = cow.cow.catalog_id
    }
    if (cow.catalog_id){
        catalog_id = cow.catalog_id
    }
//    let catalog_id = cow.cow? cow.cow.cacow.catalog_id || '___'
    console.log("ONE COW PDF", cow, catalog_id)
    if (c_type === 'light') {

        return (

            <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>

                <View style={{ flex: 1, alignSelf: 'flex-start' }}>

                    <Text>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text>
                        {cow.serial}&nbsp;
                        <Text style={styles.cowname}>{cow.name?.trim()}</Text>
                        <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                        <Text style={{ margin: 10, fontSize: '8px', }}>
                            {property_string}
                        </Text>
                    </Text>
                </View>
            </View>
        )

    } else if (c_type === 'result') {
        return (

            <View style={[styles.cow_container, { borderBottom: '1px solid #aaa', paddingTop: 5, backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]} wrap={false}>

                <View style={{ flex: 0.9, alignSelf: 'flex-start' }}>

                    <Text>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text> {cow.serial}
                        <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                        <Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                        <Text style={{ margin: 10, color: 'grey', textAlign: 'right', flexFlow: "end" }}>
                        </Text>
                    </Text>
                </View>
                <View style={{ flex: 0.1, alignSelf: 'flex-end' }}>
                    <Text style={{ marginLeft: 10, }}>
                        &nbsp;&nbsp;n°
                    </Text>
                </View>
            </View>
        )
    } else if (c_type === 'postresult') {
        console.log("RES COW", cow)

        const RADIUS = '50px'
        property_string = cow.cow.property?.name || ''
        if (cow.cow.property && cow.cow.property.provincia && cow.cow.property.provincia.length > 0) {
            property_string = property_string + " - " + cow.cow.property.provincia
        }
        if (cow.cow.coproperty && cow.cow.coproperty.length > 0) {
            property_string = property_string + " (" + cow.cow.coproperty + ") "
        }
        let cowman_string = cow.cow.cowman?.name || ''
        if (cow.cow.cowman && cow.cow.cowman.provincia && cow.cow.cowman.provincia.length > 0) {
            cowman_string = cowman_string + " - " + cow.cow.cowman.provincia
        }
        return (
            <View style={{ backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }} wrap={false}>
                {cow.award_label &&
                    <View style={styles.cow_container}>
                        <View style={{ flex: 'auto', ...styles.position }}>
                            <Text style={styles.cowname}>
                                {cow.award_label.award_name}
                            </Text>
                        </View>
                    </View>
                }
                <View style={styles.cow_container}>
                    <View style={{ flex: 0.3 }}>
                        {index >= 0 && !cow.award_label &&
                            <Text style={styles.position}>{index + 1}</Text>
                        }
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                        <Text style={styles.catalog}>{catalog_id}</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {cow.cow.serial} <Text style={styles.cowname}>{cow.cow.name?.trim()}</Text>
                            <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.cow.birthdate), 'dd/MM/yyyy')}
                            <Text style={{ ...styles.label }}>, parti:</Text> {cow.cow.birth}
                        </Text>
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                        <Text style={styles.catalog}>{cow.cow[award_value]}</Text>
                    </View>

                </View>
                <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {getCross(cow.cow)}
                        </Text>
                    </View>
                </View>
                <View style={styles.cow_container}>
                    <View style={{ flex: 0.3 }}>
                    </View>
                    <View style={{ flex: 0.3, alignContent: 'flex-end' }}>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}>prop:&nbsp;</Text>
                            {property_string}
                        </Text>
                    </View>
                </View>
            </View>
        )

    } else {
        return (
            <View style={{ backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }} wrap={false}>

                <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>{catalog_id}</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {cow.serial}&nbsp;
                            <Text style={styles.cowname}>{cow.name?.trim()}</Text>
                            <Text style={{ ...styles.label }}>, nata:</Text> {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                            <Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                        </Text>
                    </View>
                </View>
                <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>&nbsp;</Text>
                    </View>
                    <View style={{ flex: 7 }}>
                        <Text>
                            {property_string}
                        </Text>
                    </View>
                </View>
                <View style={[styles.cow_container, { backgroundColor: index % 2 === 0 ? '#ddd' : '#fff' }]}>
                    <View style={{ flex: 0.3 }}>
                        <Text style={{ ...styles.cowname, width: '10px' }}>&nbsp;</Text>
                    </View>
                    <View style={{ flex: 4 }}>
                        <Text>
                            {getCross(cow)}
                        </Text>
                    </View>
                    <View style={{ flex: 0.6 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> pft: </Text>
                            {cow.pft},
                        </Text>
                    </View>
                    <View style={{ flex: 0.6 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> ies: </Text>
                            {cow.ies},
                        </Text>
                    </View>
                    <View style={{ flex: 0.7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> ics-pr: </Text>
                            {cow.ics_pr},
                        </Text>
                    </View>
                    <View style={{ flex: 0.7 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> kg prot: </Text>
                            {cow.kg_protein_index},
                        </Text>
                    </View>
                    <View style={{ flex: 1 }}>
                        <Text>
                            <Text style={{ ...styles.label }}> KgLatGgVita: </Text>
                            {cow.milk_gg_life}
                        </Text>
                    </View>
                </View>
            </View>
        )

        return (

            <View style={[styles.cow_container_border, { backgroundColor: index % 2 === 0 ? '#eee' : 'white' }]} wrap={false}>
                <Text style={{ border: '1px solid black', alignItems: 'flex-start', textAlign: 'left' }}>
                    <Text style={styles.catalog}>{catalog_id}</Text> {cow.serial} <Text style={styles.cowname}>{cow.name?.trim()}</Text>, {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}<Text style={{ ...styles.label }}>, parti:</Text> {cow.birth}
                </Text>
                <Text style={{ marginLeft: 17 }}>
                    {property_string}
                </Text>
                <Text style={{ marginLeft: 17 }}>
                    {getCross(cow)}
                </Text>
            </View>
        )
    }

}

export default OtherlistPdf;